import { render, staticRenderFns } from "./EmployeeProficiencyParameterCreateOrUpdate.vue?vue&type=template&id=4024fef6&"
import script from "./EmployeeProficiencyParameterCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./EmployeeProficiencyParameterCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports